import { render, staticRenderFns } from "./TheWrapperDapp.vue?vue&type=template&id=255b5329"
import script from "./TheWrapperDapp.vue?vue&type=script&lang=js"
export * from "./TheWrapperDapp.vue?vue&type=script&lang=js"
import style0 from "./TheWrapperDapp.vue?vue&type=style&index=0&id=255b5329&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports